<template>
    <div class="base-radio" :class="{ 'is-disabled': disabled }">
        <label class="base-radio__label">
            <input
                type="radio"
                class="base-radio__input"
                :checked="model === value"
                :disabled="disabled"
                @change="handleChange"
            />
            <span class="base-radio__box"></span>
            <span v-if="label" class="base-radio__text">{{ label }}</span>
        </label>
        <span v-if="error" class="base-radio__error">{{ error }}</span>
    </div>
</template>

<script setup>
const model = defineModel({
    type: String,
    default: ''
});

const props = defineProps({
    value: {
        type: String,
        required: true
    },
    label: {
        type: String,
        default: ''
    },
    disabled: {
        type: Boolean,
        default: false
    },
    error: {
        type: String,
        default: ''
    },
});

const emit = defineEmits(['change']);

const handleChange = (event) => {
    if (event.target.checked) {
        model.value = props.value;
        emit('change', props.value);
    }
};
</script>

<style lang="scss" scoped>
.base-radio {
    display: inline-flex;
    flex-direction: column;
    gap: 4px;

    &__label {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        user-select: none;
        color: #212529;
        font-family: Arial;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }

    &__input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    &__box {
        position: relative;
        display: inline-block;
        width: 25px;
        height: 25px;
        border: 1px solid var(--border-color);
        border-radius: 50%;
        transition: all 0.2s ease;
        flex-shrink: 0;

        &::after {
            content: '';
            position: absolute;
            display: none;
            left: 50%;
            top: 50%;
            width: 17px;
            height: 17px;
            background-color: var(--general-color);
            border-radius: 50%;
            transform: translate(-50%, -50%);
            transition: all 0.2s ease;
        }
    }

    &__input:checked ~ &__box {
        border-color: #8c8c8c;

        &::after {
            display: block;
        }
    }

    &__text {
        font-size: 14px;
        color: #333;
    }

    &__error {
        font-size: 12px;
        color: #ff4d4f;
    }

    &.is-disabled {
        opacity: 0.6;
        cursor: not-allowed;

        .base-radio__label {
            cursor: not-allowed;
        }

        .base-radio__box {
            border-color: #d9d9d9;
            background-color: #f5f5f5;
        }
    }
}
</style>
